<template>
  <div>
    <vue-title :title="$t('results.title')" />
    <v-tabs background-color="primary" show-arrows>
      <v-tabs-slider></v-tabs-slider>
      <v-tab v-for="i in this.races" :key="i.name" @click="selectRace(i)">
        {{ i.name }}
      </v-tab>
    </v-tabs>
    <v-container fluid>
      <v-row align="center"
            justify="center">
        <v-col cols="12" xs="12" md="10">
          <ResultsCard :race="selectedRace" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import fccapi from "../fccapi.js";
import ResultsCard from "../components/ResultsCard.vue";

export default {
  name: "Results",
  data: () => ({
    headers: [
      { text: "Time", align: "left" },
      { text: "RPM", value: "requestsPerMinute", align: "right" },
      { text: "Response time", value: "averageResponseTime", align: "right" }
    ],
    races: [],
    selectedRace: null
  }),
  props: {
    source: String
  },
  components: {
    ResultsCard
  },
  methods: {
    reload: function() {
      fccapi.competitionGet("races").then(d => {
        this.races = d.data.filter(r => r.publicDisplay);
        this.selectRace(this.races[0]);
      });
    },
    selectRace: function(r){
      this.selectedRace = r;
    }
  },
  computed: {
    selectedCompetition: function() {
      return this.$store.getters["competitionId"];
    }
  },
  watch: {
    selectedCompetition() {
      console.log("changed");
      this.reload();
    }
  },
  mounted() {
    this.reload();
  },
  filters: {
    ms: function(value) {
      return Math.floor(parseFloat(value)) + " ms";
    },
    timestamp: function(value) {
      var re = new RegExp(/(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)/);
      var r = value.match(re);
      return parseInt(r[4]) + ":" + parseInt(r[5]);
    },
    fulltimestamp: function(value) {
      var re = new RegExp(/(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)/);
      var r = value.match(re);
      return r[0].replace("T", " ");
    }
  }
};
</script>